import type React from 'react';
import { CardContent, Typography, Stack, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import type { RequestProps, TestProps } from '../../models';
import { Payment } from '../../utils/payment';
import { fCurrency } from '../../utils/formatNumber';

interface TestsProps {
	tests: TestProps[];
	extraInfo?: RequestProps['extraInfo'];
	hideTestTotal?: boolean;
}

export const Tests = {
	SingleRequest: ({ tests, hideTestTotal, extraInfo }: TestsProps) => {
		return (
			<>
				<CardContent>
					<Stack spacing={2}>
						{tests.map((test) => (
							<BreakDown.SingleRequest key={test.id} {...test} />
						))}
						{!hideTestTotal && <TotalPanel tests={tests} />}
						{extraInfo && <Typography variant="subtitle1">{extraInfo}</Typography>}
					</Stack>
				</CardContent>
			</>
		);
	},
};

const BreakDown = {
	SingleRequest: ({ id, name, price }: TestProps) => {
		return (
			<Stack key={id} direction="row" justifyContent="space-between">
				<Typography variant="body1">{name}</Typography>
				<Typography variant="body1">{`$${price?.toFixed(2) || '0.00'}`}</Typography>
			</Stack>
		);
	},
};

export const TotalPanel = ({
	tests,
}: {
	tests: TestProps[];
}) => {
	const theme = useTheme();

	const payment = new Payment(tests);

	return (
		<>
			<Stack direction="row" justifyContent="space-between">
				<Typography variant="subtitle1" fontWeight="bold">
					Subtotal
				</Typography>
				<Box sx={{ textAlign: 'right' }}>
					<Typography variant="subtitle1" sx={{ color: theme.palette.common.black }} fontWeight="bold">
						{fCurrency(payment.subtotal())}
					</Typography>
				</Box>
			</Stack>
			<Stack direction="row" justifyContent="space-between">
				<Typography variant="subtitle1" fontWeight="bold">
					GST (10%)
				</Typography>
				<Box sx={{ textAlign: 'right' }}>
					<Typography variant="subtitle1" sx={{ color: theme.palette.common.black }} fontWeight="bold">
						{fCurrency(payment.gst())}
					</Typography>
				</Box>
			</Stack>
			<Stack direction="row" justifyContent="space-between">
				<Typography className="RequestTestTotalKey" variant="h4" fontWeight="bold">
					Total (inc. GST)
				</Typography>
				<Box sx={{ textAlign: 'right' }}>
					<Typography
						className="RequestTestTotalValue"
						variant="h4"
						sx={{ color: theme.palette.common.black }}
						fontWeight="bold"
					>
						{fCurrency(payment.total())}
					</Typography>
				</Box>
			</Stack>
		</>
	);
};
